import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { Skeleton } from 'primeng/skeleton';
import { CustomersService } from '@/services/customers.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

type Row = {
  date: string;           // '2025-12-22'
  total: number;
  zeynab_toosli: number;
  ahlam_mohammadi: number;
  kh_hoveyzavi: number;
  fateme_moshali: number;
  reyhane_savari: number;
};

@Component({
  selector: 'app-report-customer-active',
  standalone: true,
  imports: [CommonModule, TableModule, ToolbarModule, ButtonModule, Skeleton, ToastModule],
  providers: [MessageService],
  template: `
<p-toolbar styleClass="mb-3">
  <ng-template #start>
    آمار مشتریان فعال (۷ روز اخیر)
  </ng-template>

  <ng-template #end>
    <div class="flex gap-2">
      <p-button label="۷ روز" [outlined]="days!==7" (onClick)="setDays(7)"></p-button>
      <p-button label="۱۴ روز" [outlined]="days!==14" (onClick)="setDays(14)"></p-button>
      <p-button label="۳۰ روز" [outlined]="days!==30" (onClick)="setDays(30)"></p-button>
    </div>
  </ng-template>
</p-toolbar>

<p-table
  [value]="loading ? [] : rows"
  [loading]="loading"
  [paginator]="false"
  stripedRows
  dataKey="date"
>
  <ng-template pTemplate="loadingbody">
    <tr *ngFor="let x of [1,2,3,4,5,6,7]">
      <td colspan="7">
        <p-skeleton height="2rem"></p-skeleton>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th>تاریخ</th>
      <th>تعداد کل</th>
      <th>زینب توسلی</th>
      <th>احلام محمدی</th>
      <th>خانم حویزاوی</th>
      <th>فاطمه مشعلی</th>
      <th>ریحانه سواری</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-r>
    <tr>
      <td>{{ r.date }}</td>
      <td class="font-bold">{{ r.total }}</td>
      <td>{{ r.zeynab_toosli }}</td>
      <td>{{ r.ahlam_mohammadi }}</td>
      <td>{{ r.kh_hoveyzavi }}</td>
      <td>{{ r.fateme_moshali }}</td>
      <td>{{ r.reyhane_savari }}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="footer" *ngIf="!loading && rows?.length">
    <tr class="font-bold">
      <td>جمع</td>
      <td>{{ sum('total') }}</td>
      <td>{{ sum('zeynab_toosli') }}</td>
      <td>{{ sum('ahlam_mohammadi') }}</td>
      <td>{{ sum('kh_hoveyzavi') }}</td>
      <td>{{ sum('fateme_moshali') }}</td>
      <td>{{ sum('reyhane_savari') }}</td>
    </tr>
  </ng-template>
</p-table>

<p-toast></p-toast>
  `
})
export class DashboardActiveDailyComponent implements OnInit {
  loading = true;
  days = 7;
  rows: Row[] = [];

  constructor(
    private api: CustomersService,
    private toast: MessageService,
  ) {}

  ngOnInit() {
    this.load();
  }

  setDays(n: number) {
    this.days = n;
    this.load();
  }

  load() {
    this.loading = true;
    this.api.getActiveSellingDailyStats(this.days).subscribe({
      next: (res: any) => {
        // بک‌اند تاریخ را به صورت date می‌دهد (Date یا string)
        // اینجا استاندارد می‌کنیم به string
        this.rows = (res ?? []).map((x: any) => ({
          date: String(x.date).slice(0, 10),
          total: Number(x.total ?? 0),
          zeynab_toosli: Number(x.zeynab_toosli ?? 0),
          ahlam_mohammadi: Number(x.ahlam_mohammadi ?? 0),
          kh_hoveyzavi: Number(x.kh_hoveyzavi ?? 0),
          fateme_moshali: Number(x.fateme_moshali ?? 0),
          reyhane_savari: Number(x.reyhane_savari ?? 0),
        }));
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.toast.add({ severity: 'error', summary: 'خطا در دریافت آمار' });
      },
    });
  }

  sum(key: keyof Row) {
    return this.rows.reduce((acc, r) => acc + Number(r[key] ?? 0), 0);
  }
}
